import type { Role } from '@/domain/env/schemas';
import type { CompanyCapabilities } from '@/domain/companies/schemas';

// The roles that work in the company workspace; a supplier works elsewhere.
const WORKSPACE_ROLES: ReadonlyArray<Role> = ['accountant', 'user', 'confidential-user'];
// The roles that work in the confidential workspace as well.
const CONFIDENTIAL_WORKSPACE_ROLES: ReadonlyArray<Role> = ['accountant', 'confidential-user'];

/**
 * Every input of the case, whether a rule reads it or not: the workspace pages read the company features from the
 * store, which cannot tell they are not loaded yet, so no workspace route opens before they are known.
 */
export type CompanyWorkspaceAccessValues = {
  readonly role: Role | null;
  readonly capabilities: CompanyCapabilities;
};

export type CompanyWorkspaceAccessContext = {
  readonly inWorkspaceRoles: boolean;
  readonly inConfidentialWorkspaceRoles: boolean;
};

export const companyWorkspaceAccessContext = ({
  role,
}: CompanyWorkspaceAccessValues): CompanyWorkspaceAccessContext => ({
  inWorkspaceRoles: role !== null && WORKSPACE_ROLES.includes(role),
  inConfidentialWorkspaceRoles: role !== null && CONFIDENTIAL_WORKSPACE_ROLES.includes(role),
});
